
import { message } from "antd";
import { useAuthContext } from "./shared/context/auth-context";
import AuthencticatedApp from "./components/AuthenticatedApp/AuthenticatedApp";
import NonAuthenticatedApp from "./components/NonAuthenticatedApp/NonAuthenicatedApp";
import './App.css';


function App() {
  message.config({
    top: 100
  })

  const { token, ContractId } = useAuthContext()
  return token && ContractId ? <AuthencticatedApp /> : <NonAuthenticatedApp />
}

export default App;
